/* eslint-disable no-trailing-spaces */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable multiline-ternary */
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Descriptions, Form, Image, Input, Layout, Modal, Row, Space, Spin, Typography, notification } from 'antd'
import { CaretRightOutlined } from '@ant-design/icons'
import invert from 'invert-color'

import LogoSNI from 'src/assets/images/logo-sni.png'
import LogoMUI from 'src/assets/images/logo-mui.png'
import LogoHalal from 'src/assets/images/logo-halal.png'
import LogoUI from 'src/assets/images/logo-ui.png'
import LogoBPOM from 'src/assets/images/logo-bpom.png'
import LogoOriginal from 'src/assets/images/logo-original.png'
import CertificateEmpty from 'src/assets/images/certificate-empty.png'

import bgLeft from 'src/assets/images/Left.svg'
import bgRight from 'src/assets/images/Right.svg'
import bgBottom from 'src/assets/images/Down.svg'

import { Gap } from 'src/components/atoms/Gap'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Text from 'antd/lib/typography/Text'

import iconHerbal from 'src/assets/images/icon-herbal.png'
import iconFood from 'src/assets/images/icon-food.svg'
import iconFashion from 'src/assets/images/icon-fashion.png'

import iconFacebook from 'src/assets/images/socials/facebook-round.png'
import iconTwitter from 'src/assets/images/socials/twitter-round.png'
import iconTiktok from 'src/assets/images/socials/tiktok-round.png'
import iconInstagram from 'src/assets/images/socials/instagram-round.png'
import iconYoutube from 'src/assets/images/socials/youtube-round.png'
import iconGlobe from 'src/assets/images/socials/globe-round.png'

import ReactPixel from 'react-facebook-pixel'
import TagManager from 'react-gtm-module'
import Slider from 'react-slick'

export const _RedirectGoldG = (props) => {
  const { dispatch, data, loading, dataCoupon, dataUnique, dataPassword, dataBatch, productPixel, gtmProduct } = props
  const { pathname, search } = useLocation()
  const isGnehmp = data?.product?.sku?.startsWith('GNEHMP')
  const [locationStatus, setLocationStatus] = useState('unset')
  const [location, setLocation] = useState({
    latitude: null,
    longititude: null
  })
  const [visibleCoupon, setVisibleCoupon] = useState(false)
  const [activeCoupon, setActiveCoupon] = useState(null)
  const [alert, setAlert] = useState(false)
  const [visiblePassword, setVisiblePassword] = useState(false)
  const [loadingCouponLocation, setLoadingCouponLocation] = useState(false)
  const [loadingSubmitCoupon, setLoadingSubmitCoupon] = useState(false)
  const [savedUrlScanPage, setSavedUrlScanPage] = useState(null)
  const [savedPassword, setSavedPassword] = useState(null)
  const [hasRedirected, setHasRedirected] = useState(false)

  const [form] = Form.useForm()
  const query = new URLSearchParams(search)

  const statusError = [400, 404]

  const productionDate = pathname === '/product' && data && !statusError.includes(data.statusCode) && data?.productionDate ? data?.productionDate?.split('T') : '-'
  const expiredDate = pathname === '/product' && data && !statusError.includes(data.statusCode) && data?.expiredAt !== null ? data?.expiredAt?.split('T') : '-'
  const category = pathname === '/product' && data && !statusError.includes(data.statusCode) ? data?.product?.category : ''
  let iconTop
  const isGoldGProduct = String(data?.product?.name).toLocaleLowerCase().includes('gold-g')
  const goldGCoupon = 'GOLDG'

  switch (category) {
    case 'herbal':
      iconTop = iconHerbal
      break
    case 'food':
      iconTop = iconFood
      break
    case 'fashion':
      iconTop = iconFashion
      break
    default:
      iconTop = iconHerbal
  }

  const settings = {
    infinite: false,
    autoplay: false,
    arrows: false,
    dots: true,
    dotsClass: 'slick-dots slick-thumb',
    slidesToShow: 1.5,
    slidesToScroll: 1
  }

  useEffect(() => {
    if (pathname === '/qr') {
      const sku = query.get('sku')

      dispatch({
        type: 'scan_qr/get_scan_qr_sku',
        payload: {
          sku
        }
      })
    }

    if (pathname === '/product') {
      const qrid = query.get('qrcodeId')
      const trackId = query.get('trackId')
      const password = query.get('p')

      const body = {
        trackId
      }

      // Append password to body if exists in URL
      if (password) {
        body.password = password
      }

      dispatch({
        type: 'product_pixel/get_product_pixel_qr',
        payload: {
          qrcodeId: qrid
        }
      })
      dispatch({
        type: 'gtm_product/get_gtm_product_qr',
        payload: {
          qrcodeId: qrid
        }
      })
      dispatch({
        type: 'scan_qr/get_scan_qr_product',
        payload: {
          qrid,
          body
        }
      })

      dispatch({
        type: 'scan_qr/get_batch',
        payload: {
          qrcodeId: qrid
        }
      })
    }
  }, [pathname])

  // Save urlScanPage before it gets overwritten
  useEffect(() => {
    if (pathname === '/qr' && data?.urlScanPage && !savedUrlScanPage) {
      // Validate and format URL before saving
      let formattedUrl = data.urlScanPage.trim()

      try {
        // Check if URL has protocol, if not add https://
        if (!formattedUrl.match(/^https?:\/\//i)) {
          formattedUrl = 'https://' + formattedUrl
        }

        // Validate URL by creating URL object
        const urlObj = new URL(formattedUrl)

        // Save the valid formatted URL
        setSavedUrlScanPage(urlObj.toString())
      } catch (err) {
        console.error('Invalid URL format:', data.urlScanPage, err)
        // If invalid, don't save it
      }
    }
  }, [pathname, data?.urlScanPage, savedUrlScanPage])

  // Fetch qrcodeSetting when urlScanPage is available (for /qr path)
  useEffect(() => {
    if (pathname === '/qr' && !loading && savedUrlScanPage && data?.statusCode !== 400 && data?.qrcodeSetting === undefined) {
      try {
        // Extract qrcodeId from urlScanPage
        const urlObj = new URL(savedUrlScanPage)
        const qrcodeId = urlObj.searchParams.get('qrcodeId')

        if (qrcodeId && dataPassword) {
          // Fetch product data to check if there's a document to download
          const body = {}

          // Append unique id to body if exists
          if (savedPassword) {
            body.password = savedPassword
          }

          dispatch({
            type: 'scan_qr/get_scan_qr_product',
            payload: {
              qrid: qrcodeId,
              body
            }
          })
        }
      } catch (err) {
        console.error('Failed to parse urlScanPage:', err)
      }
    }
  }, [pathname, loading, savedUrlScanPage, data?.statusCode, data?.qrcodeSetting, dataPassword, savedPassword])

  useEffect(() => {
    if (!loading && data && data?.statusCode !== 400 && pathname !== '/product') {
      let redirectUrl = savedUrlScanPage || data?.urlScanPage

      // Check if uniqueCodeEnable is true, show modal for unique code input
      if (data?.uniqueCodeEnable && !dataPassword) {
        setVisiblePassword(true)
        return
      }

      // If already redirected, don't redirect again
      if (hasRedirected) {
        return
      }

      // Check if we need to fetch qrcodeSetting first
      if (redirectUrl && data?.qrcodeSetting === undefined) {
        // Still fetching qrcodeSetting, wait for it
        return
      }

      // Append unique code to redirect URL if exists
      const passwordToAppend = dataPassword?.generateQrcode?.codePassword || savedPassword
      if (passwordToAppend && redirectUrl) {
        try {
          const urlObj = new URL(redirectUrl)
          urlObj.searchParams.set('p', passwordToAppend)
          redirectUrl = urlObj.toString()
        } catch (err) {
          console.error('Failed to append password to redirect URL:', err)
        }
      }

      // Check if redirect URL is external (different domain)
      let isExternalRedirect = false
      try {
        const currentHost = window.location.host
        const redirectUrlObj = new URL(redirectUrl)
        const redirectHost = redirectUrlObj.host
        isExternalRedirect = currentHost !== redirectHost
      } catch (err) {
        console.error('Failed to parse redirect URL:', err)
      }

      // Mark as redirected to prevent double redirect
      setHasRedirected(true)

      // If there's a document to download AND redirecting to external site, open in new tab
      if (data?.qrcodeSetting?.document && isExternalRedirect) {
        window.open(redirectUrl, '_blank')
      } else {
        // Internal redirect or no document, proceed with normal redirect
        window.location.replace(redirectUrl)
      }
    }
  }, [loading, data, pathname, savedUrlScanPage, dataPassword, savedPassword, hasRedirected])

  useEffect(() => {
    if (productPixel) {
      const index = productPixel?.events?.findIndex(f => f.position === 'landing-page-scan')
      ReactPixel.init(productPixel.pixelId)
      ReactPixel.pageView()
      ReactPixel.track(productPixel?.events[index].eventName, {})
    }
  }, [productPixel])

  useEffect(() => {
    if (gtmProduct) {
      TagManager.initialize({
        gtmId: gtmProduct.googleTagManager
      })
    }
  }, [gtmProduct])

  useEffect(() => {
    if (!dataCoupon) {
      form.setFieldsValue({
        couponCode: null
      })
      setActiveCoupon(null)
      return
    }

    setActiveCoupon(dataCoupon)
  }, [dataCoupon])

  // Save unique id when validation is successful or from URL
  useEffect(() => {
    if (!savedPassword) {
      // Check if password exists in URL first
      const passwordFromUrl = query.get('p')
      if (passwordFromUrl) {
        setSavedPassword(passwordFromUrl)
      } else if (dataPassword?.generateQrcode?.codePassword) {
        // Otherwise, save from dataPassword when validation is successful
        setSavedPassword(dataPassword.generateQrcode.codePassword)
      }
    }
  }, [dataPassword, savedPassword])

  // Close unique code modal and trigger redirect after validation success
  useEffect(() => {
    if (dataPassword && visiblePassword) {
      setVisiblePassword(false)
    }
  }, [dataPassword, visiblePassword])

  useEffect(() => {
    const fileUrl = data?.qrcodeSetting?.document

    if (fileUrl && (!data?.uniqueCodeEnable || Boolean(savedPassword))) {
      console.log('Auto-downloading document from:', fileUrl)
      autoDownloadingDocument(fileUrl)
    }
  }, [data, savedPassword])
  
  // Auto-download PDF ebook if available in coupon response.
  useEffect(() => {
    const pdfUrl = dataCoupon?.downloadPdfEbook
    if (pdfUrl) {
      console.log('Auto-downloading PDF ebook from:', pdfUrl)
      autoDownloadingDocument(pdfUrl)
    }
  }, [dataCoupon?.downloadPdfEbookScanQr])

  const autoDownloadingDocument = (fileUrl) => {
    // eslint-disable-next-line no-undef
    fetch(fileUrl)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch file')
        return res.blob()
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = fileUrl.split('/').pop() || 'document'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      })
      .catch((err) => {
        console.error('Download error:', err)
      })
  }

  const onHandleFinishUniqueId = () => {
    const sku = query.get('sku')
    form.validateFields().then(data => {
      const body = {
        uniqueId: data?.uniqueId,
        sku: sku
      }
      
      dispatch({
        type: 'scan_qr/check_unique',
        payload: { body }
      })
    })
  }

  const onHandleFinishPassword = () => {
    const sku = query.get('sku')
    form.validateFields().then(data => {
      const body = {
        password: data?.password,
        sku: sku
      }
      
      dispatch({
        type: 'scan_qr/check_password',
        payload: { body }
      })
    })
  }
  
  const onHandleFinishCoupon = async () => {
    const index = productPixel?.events?.findIndex(f => f.position === 'submit')
    const qrid = query.get('qrcodeId')
    const trackId = query.get('trackId')
    // if (dataUnique?.uniqueCode) {
    const valueForm = form.getFieldsValue()
    form.validateFields().then((data) => {
      const body = {
        trackId,
        latitude: String(location.latitude),
        longititude: String(location.longititude),
        uniqueCode: dataUnique?.uniqueCode,
        coupon: data?.couponCode || valueForm?.couponCode || (isGoldGProduct ? goldGCoupon : undefined),
        name: data?.name || valueForm?.name,
        phone: data?.phone || valueForm?.phone,
        eventName: productPixel?.events[index].eventName || 'Purchase'
      }

      // Append email if provided
      if (data?.email || data.email !== '' || valueForm?.email) {
        body.email = data?.email || valueForm?.email
      }

      // Append password if exists
      if (savedPassword) {
        body.password = savedPassword
      }

      if (!isGoldGProduct) {
        body.isLottery = !(data?.couponCode || valueForm?.couponCode)
      }

      setLoadingSubmitCoupon(true)

      // Automatically stop loading after 7 seconds
      setTimeout(() => {
        form.resetFields()
        setLoadingSubmitCoupon(false)
        setVisibleCoupon(false)
      }, 7 * 1000)

      dispatch({
        type: 'scan_qr/get_scan_qr_product',
        payload: { qrid, body }
      })

      ReactPixel.track(productPixel?.events[index].eventName, {
        currency: 'IDR',
        value: data.product?.price
      })
    })
  }

  const checkCoupon = () => {
    const qrid = query.get('qrcodeId')
    form.validateFields().then((data) => {
      dispatch({
        type: 'coupon/check_coupon',
        payload: {
          data: {
            qrcodeId: qrid,
            coupon: data?.couponCode
          }
        }
      })
    })
  }

  const claimCoupon = () => {
    setLoadingCouponLocation(true)

    const index = productPixel?.events?.findIndex(f => f.position === 'button-popup-coupon')
    ReactPixel.track(productPixel?.events[index].eventName, {})

    navigator.geolocation.getCurrentPosition((position) => {
      setLocationStatus('on')
      setLocation({
        latitude: position.coords.latitude,
        longititude: position.coords.longitude
      })
      setVisibleCoupon(true)
      setLoadingCouponLocation(false)
    }, (error) => {
      if (error.code === error.PERMISSION_DENIED) {
        setLocationStatus('off')
        setAlert(true)
      }
      setLoadingCouponLocation(false)
    },
    {
      enableHighAccuracy: true,
      maximumAge: 0 // No cached locations
    })
  }

  const handleChangeBatch = (e) => {
    const qrid = query.get('qrcodeId')

    const body = {
      qrcodeId: qrid,
      newBatch: Number(e.currentTarget.value)
    }

    if (body.prevBatch === body.newBatch) {
      notification.warn({
        message: 'Warning',
        description: 'You are already in this batch'
      })
      return
    }

    dispatch({
      type: 'scan_qr/move_batch',
      payload: { body }
    })
  }

  const onHandleAllowLocation = () => {
    const sku = query.get('sku')
    navigator.geolocation.getCurrentPosition((position) => {
      setLocationStatus('on')
      const body = {
        latitude: position.coords.latitude,
        longititude: position.coords.longitude
      }
      dispatch({
        type: 'scan_qr/get_scan_qr_sku',
        payload: {
          sku
        }
      })
      // setLatitude(position.coords.latitude)
      // setLongitude(position.coords.longitude)
    }, (error) => {
      if (error.code === error.PERMISSION_DENIED) {
        setLocationStatus('off')
      }
    })
  }

  const fashionAttributes = (attr) => {
    switch (attr) {
      case 'model':
        return 'Model'
      case 'color':
        return 'Warna'
      case 'size':
        return 'Ukuran'
      case 'material':
        return 'Bahan'
      default:
        return null
    }
  }

  const socialMediaIcon = (sosmedName) => {
    switch (sosmedName) {
      case 'facebook':
        return iconFacebook
      case 'twitter':
        return iconTwitter
      case 'instagram':
        return iconInstagram
      case 'youtube':
        return iconYoutube
      case 'tiktok':
        return iconTiktok
      default:
        return iconGlobe
    }
  }

  return (
    <>
      {pathname === '/qr' &&
        <Layout
          className='scan-page-container webview-component' style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '2rem'
          }}
        >
          {(loading && !data?.isQrcodeExpired)
            ? (
              <>
                <Spin spinning size='large' className='mb-4' />
                RedirectGoldGing please wait...
              </>
              )
            : !loading && data?.statusCode === 400
                ? `Qrcode Has Reached Maximum Check, Scanned ${data?.data?.totalChecked || 0} Times`
                : savedUrlScanPage && data?.qrcodeSetting?.document && savedPassword
                  ? (() => {
                      // Check if redirect is external
                      let isExternalRedirect = false
                      try {
                        const currentHost = window.location.host
                        const redirectUrlObj = new URL(savedUrlScanPage)
                        const redirectHost = redirectUrlObj.host
                        isExternalRedirect = currentHost !== redirectHost
                      } catch (err) {
                        isExternalRedirect = false
                      }

                      // Only show message if redirecting to external site with document
                      if (!isExternalRedirect) return null

                      // Remove qrcodeId from URL for display
                      let displayUrl = savedUrlScanPage
                      try {
                        const urlObj = new URL(savedUrlScanPage)
                        urlObj.searchParams.delete('qrcodeId')
                        displayUrl = urlObj.toString()
                      } catch (err) {
                        displayUrl = savedUrlScanPage
                      }

                      return (
                        <Space direction='vertical' size='middle' style={{ textAlign: 'center', maxWidth: '600px' }}>
                          <Typography.Title level={3} style={{ marginBottom: 0 }}>Page Redirected</Typography.Title>
                          <Typography.Text type='secondary'>
                            This page is redirected to:
                          </Typography.Text>
                          <Typography.Link
                            href={savedUrlScanPage}
                            target='_blank'
                            style={{ wordBreak: 'break-all', fontSize: '0.95rem' }}
                          >
                            {displayUrl}
                          </Typography.Link>
                          <Typography.Text type='secondary' style={{ fontSize: '0.9rem', marginTop: '1rem' }}>
                            You can safely close this tab after the download completes.
                          </Typography.Text>
                        </Space>
                      )
                    })()
                  : null}
        </Layout>}
      {pathname === '/product' &&
        <Layout className='scan-page-container webview-component' style={{ background: 'none', position: 'relative' }}>
          {data && !statusError.includes(data.statusCode)
            ? (
              <>
                <Space direction='vertical' className='w-100 h-100'>
                  {data?.qrcodeSetting?.urlScanPage === 'IMAGE' ? (
                    <Space direction='vertical' style={{ background: 'none', height: '100vh', overflow: 'hidden' }}>
                      <div style={{ height: '100%', background: 'none', marginTop: '2rem' }}>
                        <img width='100%' src={data?.qrcodeSetting?.imageScanPage} style={{ border: '1px solid rgba(0,0,0,0.7)' }} />
                      </div>
                    </Space>
                  ) : (
                    <Card className='pb-lg-5 pb-0'>
                      <img src={bgLeft} className='bg-left' />
                      <img src={bgRight} className='bg-right' />
                      <img src={bgBottom} className='bg-bottom' />
                      <Image src={iconTop} width={48} style={{ opacity: 0.8 }} />

                      <p className='big-title-sertifikat'>
                        <span>CERTIFICATE</span>
                        <br />
                        {(!data.expiredAt && !data.limitCheck) ? null : 'Original Product'}
                      </p>
                      <div className='logo-wrapper'>
                        <div className='ant-image' style={{ width: 150 }}>
                          <img className='ant-image-img' src={data.product.images[0] ? data.product.images[0].url : iconTop} style={{ borderRadius: 20 }} />
                          {/* {(!data.expiredAt && !data.limitCheck) ? null : <img src={LogoOriginal} className='bg-original' />} */}
                          {!dataUnique ? null : <img src={LogoOriginal} className='bg-original' />}
                          {(!data.expiredAt && !data.limitCheck) ? null : <img src={LogoOriginal} className='bg-original' />}
                        </div>
                      </div>
                      <Gap height='.6rem' />
                      <Layout.Content className='certificate-description px-0 px-md-3 px-lg-3'>
                        {data?.displayMode === 'full' &&
                          <>
                            <Row justify='center' className='description-items' style={{ padding: 0 }}>
                              <Descriptions.Item>
                                <div className='d-flex justify-content-between w-50 text-left'>Nama Produk
                                  <Text>:</Text>
                                </div>
                              </Descriptions.Item>
                              <span className='text-right w-50 pl-1'>{data.product.name}</span>
                            </Row>
                            <Gap height='.6rem' />
                          </>}
                        {data?.displayMode === 'full' &&
                          <>
                            <Row justify='center' className='description-items hover' style={{ padding: 0 }}>
                              <Descriptions.Item>
                                <div className='d-flex justify-content-between w-50 text-left'>Diproduksi Oleh
                                  <Text>:</Text>
                                </div>
                              </Descriptions.Item>
                              <span className='text-right w-50 pl-1'>{data.product.producedBy}</span>
                            </Row>
                            <Gap height='.6rem' />
                            <Row justify='center' className='description-items' style={{ padding: 0 }}>
                              <Descriptions.Item>
                                <div className='d-flex justify-content-between w-50 text-left'>Importir
                                  <Text>:</Text>
                                </div>
                              </Descriptions.Item>
                              <Space className='text-right w-50 pl-1' direction='vertical'>
                                {!!data?.distros?.length && (
                                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {
                                  data?.distros?.map((item, index) => {
                                    return <span key={index} className='text-right w-100 pl-1'>{item.name}</span>
                                  })
                                }
                                  </div>
                                )}
                                <span className='text-right w-50 pl-1'>{data.product.distributedBy}</span>
                              </Space>
                            </Row>
                            <Gap height='.6rem' />
                            {productionDate !== '-' && (
                              <>
                                <Row justify='center' className='description-items' style={{ padding: 0 }}>
                                  <Descriptions.Item>
                                    <div className='d-flex justify-content-between w-50 text-left'>Tanggal Produksi
                                      <Text>:</Text>
                                    </div>
                                  </Descriptions.Item>
                                  <span className='text-right w-50 pl-1'>{productionDate[0] ? productionDate[0] : productionDate}</span>
                                </Row>
                                <Gap height='.6rem' />
                              </>
                            )}
                            {expiredDate !== '-' && (
                              <>
                                <Row justify='center' className='description-items' style={{ padding: 0 }}>
                                  <Descriptions.Item>
                                    <div className='d-flex justify-content-between w-50 text-left'>Tanggal Expired
                                      <Text>:</Text>
                                    </div>
                                  </Descriptions.Item>
                                  <span className='text-right w-50 pl-1'>{expiredDate[0] ? expiredDate[0] : expiredDate}</span>
                                </Row>
                                <Gap height='.6rem' />
                              </>
                            )}
                            {
                          data.product.licenses.map((item, index) => {
                            return (
                              <div key={index}>
                                <Row justify='center' className='description-items hover' style={{ padding: 0 }}>
                                  <Descriptions.Item>
                                    <div className='d-flex justify-content-between w-50 text-left'>{item.type}
                                      <Text>:</Text>
                                    </div>
                                  </Descriptions.Item>
                                  <span className='text-right w-50 pl-1'>{item.no}</span>
                                </Row>
                                <Gap height='.6rem' />
                              </div>
                            )
                          })
                        }
                            {data?.customCode && (
                              <>
                                <Row justify='center' className='description-items hover' style={{ padding: 0 }}>
                                  <Descriptions.Item>
                                    <div className='d-flex justify-content-between w-50 text-left'>Batch No
                                      <Text>:</Text>
                                    </div>
                                  </Descriptions.Item>
                                  <span className='text-right w-50 pl-1'>{data.customCode}</span>
                                </Row>
                                <Gap height='.6rem' />
                              </>
                            )}
                            {
                          data.product.category === 'fashion'
                            ? (
                                data.product.attributes.map((item, index) =>
                                  <div key={index}>
                                    <Row justify='center' className='description-items hover' style={{ padding: 0, marginBottom: '.6rem' }} key={index}>
                                      <Descriptions.Item>
                                        <div className='d-flex justify-content-between w-50 text-left'>
                                          {
                                          fashionAttributes(item.key)
                                        }
                                          <Text>:</Text>
                                        </div>
                                      </Descriptions.Item>
                                      <span className='text-right w-50 pl-1'>{item.value}</span>
                                    </Row>
                                    <Gap height='.6rem' />
                                  </div>
                                )
                              )
                            : null
                        }
                            {data.batchSize > 1 &&
                              <>
                                <Row justify='center' className='description-items hover' style={{ padding: 0 }}>
                                  <Descriptions.Item>
                                    <div className='d-flex justify-content-between w-50 text-left'>Batch
                                      <Text>:</Text>
                                    </div>
                                  </Descriptions.Item>
                                  <span className='text-right w-50 pl-1'>{data.batch}</span>
                                </Row>
                                <Gap height='.6rem' />
                              </>}
                          </>}
                      </Layout.Content>
                      <Gap height='1rem' />
                      {data.product.socials &&
                        <>
                          <Gap height='1rem' />
                          <Row justify='center' align='middle'>
                            <Col span={24} className='socials'>
                              {data.product.socials.map((social, index) => {
                                return (
                                  <a key={index} target='_blank' href={social?.url} rel='noreferrer'>
                                    <img src={socialMediaIcon(social?.name.toLowerCase())} alt={'icn-' + social?.name.toLowerCase()} />
                                  </a>
                                )
                              })}

                            </Col>
                          </Row>
                        </>}
                      {data.product.certificates.length > 0 &&
                        <>
                          <Gap height='1rem' />
                          <Row justify='center'>
                            <Col span={24} className='carousel'>
                              <h5>Sertifikat</h5>
                              <Slider {...settings}>
                                {data.product.certificates.map(c =>
                                  <div className='carousel-item' key={c?.id}>
                                    <div className='carousel-image-wrapp'>
                                      <Image className='carousel-image' src={c?.url ?? CertificateEmpty} alt={`cert-${c?.id}`} />
                                    </div>
                                    <div className='carousel-text'>
                                      {c?.data}
                                    </div>
                                  </div>
                                )}
                              </Slider>
                            </Col>
                          </Row>
                        </>}
                      <Gap height='1rem' />
                      {data?.totalCheckedEnable && data?.totalChecked && (
                        <>
                          <Row justify='center'>
                            <Layout.Content className='footer-description'>
                              <span>
                                Sudah dipindai {data.totalChecked} kali.
                              </span>
                            </Layout.Content>
                          </Row>
                          <Gap height='1rem' />
                        </>
                      )}
                      <Row justify='center'>
                         <Layout.Content className='footer-description'>
                           {isGnehmp
                             ? <img src='/assets/logo-sertifikat-keaslian.jpeg' alt='logo-sertifikat-keaslian' style={{ width: 180 }} />
                             : <span>
                               Sertifikat keaslian produk telah dijamin keasliannya oleh OPIM.
                               Segala tindakan pemalsuan akan dipidana sesuai hukum yang berlaku.
                               <br />
                               <Gap height='1rem' />
                               @2021 Ori Premium Indonesia Market
                             </span>}
                         </Layout.Content>
                       </Row>
                      <Row justify='center' gutter={16} className='pb-lg-5 pb-0'>
                        <Space size='large'>
                          {
                      data.product.licenses.filter(item => isGnehmp ? !['halal', 'bpom'].includes(item.type) : true).map((item, index) => {
                        const data = item.type === 'halal-mui'
                          ? <Image src={LogoMUI} preview={false} width={50} key={index} />
                          : item.type === 'sni'
                            ? <Image src={LogoSNI} preview={false} width={40} key={index} />
                            : item.type === 'ui'
                              ? <Image src={LogoUI} preview={false} width={50} key={index} />
                              : item.type === 'halal'
                                ? <Image src={LogoHalal} preview={false} width={50} key={index} />
                                : item.type === 'bpom'
                                  ? <Image src={LogoBPOM} preview={false} width={50} key={index} />
                                  : null
                        return data
                      })
                    }
                        </Space>
                      </Row>
                    </Card>
                  )}
                  <Modal
                    title='⚠️ Penting!'
                    visible={alert}
                    onCancel={() => setAlert(!alert)}
                    footer={false}
                    bodyStyle={{ textAlign: 'center' }}
                    closable
                  >
                    Aktifkan izin lokasi terlebih dahulu dibrowser anda untuk dapat melakukan claim coupon
                  </Modal>
                  <Modal
                    title='Masukan Data'
                    visible={visibleCoupon}
                    onOk={() => setVisibleCoupon(!visibleCoupon)}
                    onCancel={() => setVisibleCoupon(!visibleCoupon)}
                    footer={false}
                    bodyStyle={{ textAlign: 'center' }}
                    closable
                    className='modal-claim'
                  >
                    <Form form={form} layout='vertical' autoComplete='off' className='d-flex flex-row align-items-center flex-wrap' onFinish={onHandleFinishCoupon}>
                      <Form.Item label='Nama' className='w-100 mr-2' name='name' required>
                        <Input placeholder='Name' size='large' required />
                      </Form.Item>
                      <Form.Item label='No. Telp' className='w-100 mr-2' name='phone' required>
                        <Input placeholder='60xxxx' size='large' required />
                      </Form.Item>
                      <Form.Item label='Email' className='w-100 mr-2' name='email'>
                        <Input placeholder='Email' size='large' type='email' />
                      </Form.Item>
                      {!isGoldGProduct && (
                        <div className='coupon-form' style={{ flexDirection: 'column' }}>
                          <div className='d-flex justify-content-between' style={{ width: '100%' }}>
                            <Form.Item label='Code Coupon' className='mr-2 customColumn' style={{ width: '80%' }} name='couponCode' required>
                              <Input placeholder='Code Coupon' size='large' required />
                            </Form.Item>
                            <Form.Item className='mr-2' style={{ marginTop: 'auto' }}>
                              <Button type='primary' size='medium' loading={loading} onClick={() => checkCoupon()} style={{ backgroundColor: '#4500BA', borderColor: '#4500BA' }}>
                                Check
                              </Button>
                            </Form.Item>
                          </div>
                          {(dataCoupon && dataCoupon?.coupon) &&
                            <div className='ant-alert-info' style={{ marginBottom: 24, textAlign: 'left', backgroundColor: '#27AE6033', borderColor: '#27AE60', borderRadius: 10 }}>
                              <Col span={24} className='py-2 px-4'>
                                <div className='mb-1' style={{ fontWeight: 'bold' }}>{dataCoupon?.coupon}</div>
                                <div style={{ fontSize: 13 }}>
                                  {`Dapatkan Diskon ${dataCoupon?.discountCalculated?.percentage}% `} untuk pembelian selanjutnya pada produk yang sama
                                </div>
                              </Col>
                            </div>}
                        </div>
                      )}
                      <Form.Item style={{ width: '100%', marginTop: '12px' }}>
                        <Button type='primary' size='medium' htmlType='submit' loading={loadingSubmitCoupon} style={{ width: '100%', backgroundColor: '#4500BA', borderColor: '#4500BA', padding: '10px 24px', height: 'auto' }}>
                          {(!data?.qrcodeSetting?.buttonSubmit || data?.qrcodeSetting?.buttonSubmit?.showCustomSubmitButton === 'DEFAULT')
                            ? (
                                'Submit'
                              ) : (
                                data?.qrcodeSetting?.buttonSubmit?.customSubmitText || 'Submit'
                              )}
                        </Button>
                      </Form.Item>
                    </Form>
                  </Modal>
                  {!data?.qrcodeSetting?.buttonClaim || (data?.qrcodeSetting?.buttonClaim && data?.qrcodeSetting?.buttonClaim.showCustomClaimButton === 'DEFAULT')
                    ? (
                      <div className='scan-claim-popup'>
                        <Button
                          type='primary'
                          className='claim-btn claim-popup-btn'
                          title='Claim Coupon/Ikut Undian'
                          onClick={claimCoupon}
                          loading={loadingCouponLocation}
                        >
                          CLAIM COUPON / IKUT UNDIAN
                        </Button>
                      </div>
                      ) : (
                        <div className={`scan-claim-popup scan-claim-popup-${data?.qrcodeSetting?.buttonClaim?.buttonVerticalPosition}-${data?.qrcodeSetting?.buttonClaim?.buttonHorizontalPosition}`}>
                          <Button
                            type='primary'
                            className='claim-popup-btn'
                            title={data?.qrcodeSetting?.buttonClaim?.buttonText || 'Claim Coupon/Ikut Undian'}
                            onClick={claimCoupon}
                            loading={loadingCouponLocation}
                            style={{
                              backgroundColor: data?.qrcodeSetting?.buttonClaim?.buttonColor || '#4500BA',
                              borderColor: data?.qrcodeSetting?.buttonClaim?.buttonColor || '#4500BA',
                              color: invert(data?.qrcodeSetting?.buttonClaim?.buttonColor || '#4500BA', true)
                            }}
                          >
                            {data?.qrcodeSetting?.buttonClaim?.buttonText || 'CLAIM COUPON / IKUT UNDIAN'}
                          </Button>
                        </div>
                      )}
                  {!dataBatch?.batchLock && dataBatch?.batchSize > 1 && data?.batch === 0
                    ? (
                      <div className='scan-claim-popup' style={{ top: 0, bottom: 'auto', paddingTop: '30px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', position: 'relative', overflow: 'auto', height: '93vh' }}>
                          {[...Array(dataBatch?.batchSize + 1)].map((_, i) => {
                            const text = `${i === 0 ? 'TOTAL' : `BATCH ${i}`} (${dataBatch?.batchCount[i] ?? 0})`
                            return (
                              <Button
                                key={i}
                                type='primary'
                                className='claim-btn claim-popup-btn'
                                style={{ margin: 0, color: 'white' }}
                                title={text}
                                value={i}
                                onClick={handleChangeBatch}
                                disabled={i === 0}
                              >
                                {dataBatch?.batch === i
                                  ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                                      <CaretRightOutlined style={{ color: 'yellow' }} /> {text}
                                    </div>
                                    )
                                  : text}
                              </Button>
                            )
                          })}
                        </div>
                      </div>
                      )
                    : null}
                </Space>
              </>
              )
            : data && statusError.includes(data.statusCode) && data.message === 'Qrcode Has Reached Maximum Check'
              ? <span className='text-center px-4'>QR Rusak, produk tidak terjamin. Silahkan tanyakan kepada penjual</span>
              : data && statusError.includes(data.statusCode) && data.message === "Unique Code Doesn't Matched"
                ? <span className='text-center px-4'>Unique Code tidak valid silahkan refresh dan coba lagi!</span>
                : <Spin spinning size='large' className='spin-height' />}
        </Layout>}
      <Modal
        title='Input Code Password'
        visible={visiblePassword}
        footer={false}
        bodyStyle={{ textAlign: 'center' }}
        closable={false}
      >
        <Gap height='2rem' />
        <Form form={form} className='d-flex flex-row align-items-center flex-wrap' onFinish={onHandleFinishPassword}>
          <Form.Item className='w-75 mr-2' name='password' required>
            <Input placeholder='Type your code password' size='large' />
          </Form.Item>
          <Form.Item>
            <Button type='primary' size='medium' htmlType='submit' loading={loading}>Check</Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

const mapStateToProps = ({ reducerScanQR, reducerProductPixel, reducerCoupons, reducerProductGtm }) => {
  return { ...reducerScanQR, ...reducerProductPixel, ...reducerCoupons, ...reducerProductGtm }
}

export const RedirectGoldG = connect(mapStateToProps)(_RedirectGoldG)

_RedirectGoldG.propTypes = {
  loading: PropTypes.bool,
  dispatch: PropTypes.func,
  data: PropTypes.object,
  dataCoupon: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array]),
  dataUnique: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array]),
  dataPassword: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array]),
  dataBatch: PropTypes.object,
  productPixel: PropTypes.PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array]),
  gtmProduct: PropTypes.PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array])
}
